// extracted by mini-css-extract-plugin
module.exports = {"timerSlide":"Knv_fE","countdown":"_2jCuXY","title":"_3elgJX","content":"_2oTJMQ","withoutCounter":"_3YJ3LW"};